// window.addEventListener('pplrAppInitiated' , function(e) {
//   const targetNode = document.getElementById("pplr_canvas");
//   const observer = new MutationObserver((mutations) => {
//       mutations.forEach((mutation) => {
//         if (mutation.addedNodes.length > 0) {
//           console.log("Inside Mutation Observer: ", targetNode)
//           const parentElement = targetNode?.parentElement;
//           if (parentElement) {
//             parentElement.style.display = "none";
//           }
//         }
//       });
//     });
  
//   $(document).on('click', '.close_monogram_tool', function() {
      
//       observer.observe(document.body, { childList: true });
    
//     // $("#pplr_canvas").parent().remove();
//     // $("div.product__media.media").removeClass("pplr");
//   })

//   $("#btn-add-remove-monogram").click(function() {
//     observer.disconnect();
//   });
// })

function checkAndRemoveElement(className = ".pplr_preview_wrapper") {
  const element = document.querySelector(className);
  if (element) {
    const parentElement = element.parentElement;
    element.remove();
    parentElement.classList.remove("pplr");
  }
}

window.addEventListener('pplrAppInitiated' , function(e) {
   $(document).on('click', '.close_monogram_tool', function() {
    $(".pplr_preview_wrapper").addClass('d-none');
    const intervalId = setInterval(checkAndRemoveElement, 1000);
  
    // Listen for click on the "btn-add-remove-monogram" element
    $('#btn-add-remove-monogram').one('click', function() {
      clearInterval(intervalId); // Stop the interval
      $(".pplr_preview_wrapper").removeClass('d-none');
      checkAndRemoveElement(); // Revert the element removal immediately
    });
  });
})